// src/lib/clientShare.js — what leaving a client actually does.
//
// Owner, 2026-09-02: "opting out mean giving away as lead but sharing mean they stay and add
// someone else too."
//
// ⚠️ ITS OWN MODULE because it is the most important decision on the share panel and the least
// testable in place: the sentence it chooses appears only after a click, so a static render
// cannot reach it, and `node --test` cannot import a .jsx file at all.
//
// The two outcomes are OPPOSITE FACTS about a person the agent has been phoning:
//   handover — a colleague still represents them, so leaving hands the client to them
//   pool     — nobody else does, so the client returns to the client-lead pool for anyone
// An agent who reads "it becomes theirs" when the truth is "anyone can take them" stops
// following up on a client who is now nobody's.

/**
 * @param {Array<{party_id?:string, name?:string}>} representatives
 * @param {string|null} myPartyId
 * @returns {{ kind: 'handover'|'pool', others: Array }}
 */
export function leaveOutcome(representatives, myPartyId) {
  // ⚠️ A row with no party_id cannot be shown to BE someone else, so it does not count as a
  // colleague — counting it would promise a handover to a person the panel cannot name.
  const others = (representatives || []).filter(r => r && r.party_id && r.party_id !== myPartyId)
  return { kind: others.length ? 'handover' : 'pool', others }
}
